import routes from "../../../engine/routes";
import React from "react";
import { useParams } from "react-router-dom";
import { RenderMenuSider } from "../../../engine/AuthRoute/navigationHelper";
import { useSelector } from "react-redux";
import {
  renderBillStatus,
  renderStatusPrestation,
  renderUserName,
  roles,
} from "../../../utils/constants";
import { useTranslation } from "react-i18next";
import { userHasLevel } from "../../../engine/AuthRoute";

export const BillingSlider = () => {
  const { id } = useParams();
  const { t } = useTranslation();

  const { bill } = useSelector(state => state.bill);

  const billMenuDetail = {
    title: routes.billing().detail.title,
    root: routes.billing(),
    children: [routes.billing(id).detail, routes.billing(id).edition],
  };

  return (
    <RenderMenuSider
      menu={billMenuDetail}
      extra={
        <div className={"specialWidthtags"}>{renderBillStatus(bill, t)}</div>
      }
    />
  );
};
